{
  "version": 1,
  "asset_id": "25a7b0af-e68d-4851-ba68-7924553e247c",
  "project_id": "1d7b8e6b-eeef-4a52-9dda-b5fbba0dd955",
  "url": "/__l5e/assets-v1/25a7b0af-e68d-4851-ba68-7924553e247c/solar-roof-aerial.webp",
  "r2_key": "a/v1/1d7b8e6b-eeef-4a52-9dda-b5fbba0dd955/25a7b0af-e68d-4851-ba68-7924553e247c/solar-roof-aerial.webp",
  "original_filename": "solar-roof-aerial.webp",
  "size": 521338,
  "content_type": "image/webp",
  "created_at": "2026-07-28T15:10:31Z"
}
